import styled from "styled-components";
import { COLORS } from "@bikdotai/bik-component-library";

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px 0;
  position: sticky;
  top: 0;
  background: white;
`;

export const VersionRow = styled.div<{ selected: boolean }>`
  padding: 12px;
  margin-right: 16px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid
    ${(props) => (props.selected ? COLORS.stroke.brand : COLORS.stroke.primary)};
  margin-bottom: 8px;
`;

export const RowLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const SourceBadge = styled.span`
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  background: ${COLORS.background.base};
  color: ${COLORS.content.secondary};
  white-space: nowrap;
`;

export const DiffBox = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid ${COLORS.stroke.primary};
`;

export const UndoList = styled.ul`
  margin: 4px 0 0;
  padding-left: 18px;
`;
